function toCss(name, object = {}) {
  return `${Object.entries(object).reduce((acc, [key, value]) => `${acc}${key}:${value};`, `${name}{`)}}`;
}

export default {
  toCss,
};
